import React from 'react';
import type { ServicesAppLayoutWithProjectContext as ServicesAppLayoutWithProjectContextType } from '@atlassian/jira-spa-apps-servicedesk-services-with-project-context/src/ui/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskServicesWithProjectContext = lazyForPaint<
	typeof ServicesAppLayoutWithProjectContextType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-services-with-project-context", jiraSpaEntry: "async-servicedesk-services-with-project-context" */ '@atlassian/jira-spa-apps-servicedesk-services-with-project-context'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyServicedeskServicesWithProjectContext}
		pageId="spa-apps/servicedesk/services"
		shouldShowSpinner
	/>
);
